import { Component, computed, input } from '@angular/core';
import { BackgroundAnimationComponent } from '@shared/components/background-animation/background-animation.component';
import { VideoSignedSrcDirective } from '@shared/directives/video-signed-src.directive';
import {
  BackgroundAsset,
  BackgroundAssetType,
  BackgroundObjectFit,
  NONE_BACKGROUND_ASSET,
} from './background.model';

/**
 * Single, extensible entry point for rendering any kind of background
 */
@Component({
  selector: 'od-background',
  imports: [BackgroundAnimationComponent, VideoSignedSrcDirective],
  templateUrl: './background.component.html',
  styleUrls: ['./background.component.scss'],
})
export class BackgroundComponent {
  public readonly asset = input<BackgroundAsset>(NONE_BACKGROUND_ASSET);

  protected readonly BackgroundAssetType = BackgroundAssetType;
  protected readonly BackgroundObjectFit = BackgroundObjectFit;

  protected readonly mediaAsset = computed(() => {
    const asset = this.asset();
    return asset.type === BackgroundAssetType.Image ||
      asset.type === BackgroundAssetType.Video
      ? asset
      : null;
  });

  protected readonly animationAsset = computed(() => {
    const asset = this.asset();
    return asset.type === BackgroundAssetType.Animation
      ? asset.animation
      : null;
  });
}
